import ImageSlot from "./ImageSlot";

import styles from "./ImageLayoutWide4.module.css";

interface Props {
    editing?: boolean;
    images: { [key: string | number]: File | string | null };
    onImageChange?: (key: string | number, newImage: File | null) => void;
}

export default function ImageLayoutWide4({
    editing,
    images,
    onImageChange,
}: Props) {
    return (
        <div className={styles.imageContainer}>
            <div className={styles.imageGrid}>
                <ImageSlot
                    image={images[0]}
                    width={515}
                    height={280}
                    onImageChange={(img) => {
                        if (onImageChange) onImageChange(0, img);
                    }}
                    editing={editing}
                />
                <ImageSlot
                    image={images[1]}
                    width={515}
                    height={280}
                    onImageChange={(img) => {
                        if (onImageChange) onImageChange(1, img);
                    }}
                    editing={editing}
                />
                <ImageSlot
                    image={images[2]}
                    width={515}
                    height={280}
                    onImageChange={(img) => {
                        if (onImageChange) onImageChange(2, img);
                    }}
                    editing={editing}
                />
                <ImageSlot
                    image={images[3]}
                    width={515}
                    height={280}
                    onImageChange={(img) => {
                        if (onImageChange) onImageChange(3, img);
                    }}
                    editing={editing}
                />
            </div>
            <ImageSlot
                label="Cover Image"
                image={images.cover}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange("cover", img);
                }}
                editing={editing}
            />
        </div>
    );
}
